import { Machine, assign, sendParent } from 'xstate';
import { isWpSuccess, wpFetchRestApi } from '../util';
;
;
const assignError = assign({
    error: (__, event) => event.data,
});
const clearValues = assign({
    values: (__, ___) => ({ for_sale: true }),
});
const logError = (__, evt) => {
    console.log({ evt });
    console.log(evt.data.toString());
};
export const newMachine = Machine({
    id: 'edit-machine',
    initial: 'editing',
    states: {
        editing: {
            on: {
                SAVE: 'saving',
            },
        },
        saving: {
            invoke: {
                src: 'saveType',
                onDone: {
                    target: 'editing',
                    actions: [
                        'clearValues',
                        sendParent('SAVED'),
                    ],
                },
                onError: {
                    target: 'error',
                    actions: ['assignError', logError],
                },
            },
        },
        error: {
            on: {
                SAVE: 'saving',
            },
        },
    }
}, {
    services: {
        saveType: saveType,
    },
    actions: {
        clearValues: clearValues,
        assignError: assignError,
    },
});
async function saveType(ctx) {
    const values = ctx.values;
    const endpoint = 'meeting-type/';
    const result = await wpFetchRestApi(endpoint, 'POST', values);
    if (isWpSuccess(result)) {
        return result.data;
    }
    throw new Error(result.message);
}
export function createNewMachine() {
    const values = { for_sale: true };
    return newMachine.withContext({ values });
}
;
